import { createSelector } from 'reselect'

export const getListFoodAdded = createSelector(
    [state => state.OrderReducer.ordering],
    ordering => ordering
)

export const getListFoodById = (ids, all, field = 'id') =>
    createSelector([state => state.OrderReducer.ordering], ordering =>
        ordering.reduce((rs, f, index) => {
            if (
                !ids.includes(
                    all
                        ? f[field] ?? f.foodDetails?.[field]
                        : f.foodDetails?.[field]
                )
            ) {
                return rs
            }

            return [
                ...rs,
                {
                    ...f,
                    indexInCart: index,
                },
            ]
        }, [])
    )

export const getFoodById = id =>
    createSelector([state => state.OrderReducer.ordering], ordering => {
        if (id === false) {
            return null
        }

        let indexInCart = -1

        for (let i = ordering.length - 1; i > -1; i--) {
            const f = ordering[i]
            if (!f.submitted && f.foodDetails?.id === id) {
                indexInCart = i
                break
            }
        }

        return indexInCart !== -1
            ? { ...ordering[indexInCart], indexInCart }
            : null
    })

export const getDeliverInfo = createSelector(
    [state => state.OrderReducer],
    order => order.deliverPosition
)

export const isValidAddressForCalcDistance = createSelector(
    [state => state.OrderReducer.deliverPosition],
    deliverInfo => {
        const { userAddressNumber, userStreet, userCity } = deliverInfo || {}

        return (userAddressNumber && userStreet && userCity)
    }
)

export const canAddMoreGroup = createSelector(
    [
        state => state.OrderReducer.ordering,
        state => state.OrderReducer.listGroupOrder,
    ],
    (ordering, listGroupOrder) => {
        const lastGroup = listGroupOrder[listGroupOrder.length - 1]
        const foodInLastGroup = ordering.filter(food => food.groupOrder === lastGroup)
        return !!foodInLastGroup.length
    }
)